module.exports = __webpack_public_path__ + "img/exclamation-circle.44d95198.svg";